import { render, staticRenderFns } from "./playerDetail_basePanel.vue?vue&type=template&id=3822ab12&scoped=true"
import script from "./playerDetail_basePanel.vue?vue&type=script&lang=js"
export * from "./playerDetail_basePanel.vue?vue&type=script&lang=js"
import style0 from "./playerDetail_basePanel.vue?vue&type=style&index=0&id=3822ab12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822ab12",
  null
  
)

export default component.exports